/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import { queryKeys } from "./queryKeys";

export const invalidateClientTerms = (queryClient, terms) => {
  if (!terms || Object.keys(terms).length === 0) return;

  queryClient.invalidateQueries({ queryKey: queryKeys.client.terms });
  queryClient.invalidateQueries({ queryKey: queryKeys.client.userTerms });
  queryClient.invalidateQueries({ queryKey: queryKeys.client.cancellationTerms });
  queryClient.invalidateQueries({ queryKey: queryKeys.client.privacyPolicy });
};
